import { render } from "./AdsBanner.vue?vue&type=template&id=3bcfee38&scoped=true"
import script from "./AdsBanner.vue?vue&type=script&lang=js"
export * from "./AdsBanner.vue?vue&type=script&lang=js"

import "./AdsBanner.vue?vue&type=style&index=0&id=3bcfee38&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcfee38"]])

export default __exports__